/**
 * CAPA DE DATOS (DL): ROULETTE
 * Comunicación directa con la API .NET en producción.
 */

const SaveConfig = async (configData) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Roulette/SaveConfig`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(configData)
        });
        if (!response.ok) throw new Error('Error al guardar configuración de la ruleta');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

const GetConfig = async (targetScreenId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Roulette/GetConfig/${targetScreenId}`);
        if (!response.ok) throw new Error('No se encontró configuración para esta ruleta');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

const PrepareScreen = async (screenId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Roulette/PrepareScreen/${screenId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) throw new Error('Error al preparar la ruleta');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

const ExecuteSpin = async (dataPayload) => {
    try {
        const requestBody = {
            targetScreenId: dataPayload.targetScreenId,
            playerName: dataPayload.playerName || 'Aficionado',
            playerContact: dataPayload.playerContact || ''
        };
        const response = await fetch(`${process.env.REACT_APP_API_URL}Roulette/Spin`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody)
        });
        if (!response.ok) throw new Error('Error al ejecutar el giro de la ruleta');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export { SaveConfig, GetConfig, PrepareScreen, ExecuteSpin };
